"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeSelect = TreeSelect;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const TreeSelect_style_1 = require("./TreeSelect.style");
function TreeSelect(props) {
    return (0, jsx_runtime_1.jsx)(TreeSelect_style_1.StyledTreeSelect, { ...getDefaultProps(), ...props });
}
TreeSelect.TreeNode = TreeSelect_style_1.StyledTreeSelect.TreeNode;
TreeSelect.SHOW_PARENT = TreeSelect_style_1.StyledTreeSelect.SHOW_PARENT;
TreeSelect.SHOW_ALL = TreeSelect_style_1.StyledTreeSelect.SHOW_ALL;
TreeSelect.SHOW_CHILD = TreeSelect_style_1.StyledTreeSelect.SHOW_CHILD;
const getDefaultProps = () => {
    return {
        tagRender: tagProps => (0, jsx_runtime_1.jsx)(elements_1.SelectTag, { ...tagProps }),
    };
};
